import { Size } from '@spryker-oryx/utilities';

export enum DefaultSize {
  Sm = Size.Sm,
  Md = Size.Md,
  Lg = Size.Lg,
}
